import React, { useEffect } from 'react';
import './assets/scss/themes.scss';
import './assets/scss/theme-hydro.scss';
import Routes from './Routes';
import { useSelector } from 'react-redux';
import { setAuthorization } from './helpers/api_helper';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const token = useSelector(state => state.Login.user?.token);

  useEffect(() => {
    if (token) {
      setAuthorization(token);
    }
  }, [token]);

  return (
    <>
      <Routes />
      <ToastContainer limit={1} />
    </>
  );
}

export default App;

// import React from "react";
// import "./assets/scss/themes.scss";
// import Route from "./Routes";
// function App() {
//   return (
//     <React.Fragment>
//       <Route />
//     </React.Fragment>
//   );
// }
// export default App;

// import { AuthProvider } from "oidc-react";
// const oidcConfig = {
//   onSignIn: () => {
//     // Redirect?
//     navigate("/dashboard");
//   },
//   authority: "https://login-v3.qa.idaman.pertamina.com",
//   clientId: "8005b875-3ab3-40ec-a138-9ca27c67dbe1",
//   redirectUri: "http://localhost:9092/dashboard",
//   ClientSecret: "be8efdd3-e0b1-4e9e-96a7-c356d6335e30",
//   Scopes: "openid, profile, email",
// };
// function App() {
//   return (
//     <AuthProvider {...oidcConfig}>
//       <Route />
//     </AuthProvider>
//   );
// }
// export default App;
